/**
 * @file radio-group
 */
import { CheckGroup as InnerCheckGroup } from './Group';
import { CheckGroupCheckbox } from './Checkbox';
import { CheckGroupButton } from './Button';
import { CheckGroupBlock } from './Block';
export var CheckGroup = Object.assign(InnerCheckGroup, {
  Checkbox: CheckGroupCheckbox,
  Button: CheckGroupButton,
  Block: CheckGroupBlock
});